import React, { useState } from 'react';
import AppShell from '../components/AppShell';
import Tabs from '../components/Tabs';
import PackageBalancesPanel from '../components/packages/PackageBalancesPanel';
import PackageTemplatesPanel from '../components/packages/PackageTemplatesPanel';
import s from '../components/packages/packages.module.css';

// `Packages`.
//
// MMS's is one page with two tabs, `Package Balances` and `Templates` (#181,
// #369), in that order. `Package Balances` opens: templates are set up once
// and balances are read every week.
//
// The balances tab does not carry `+ Add Package` or `Actions ▸ Apply Lesson
// Prices and Package Time`; `PackageBalancesPanel` says why.
//
// Laid out as FamiliesPage is (#570): the shared `Tabs` inside a `.page` with
// the same gutters, and each tab a toolbar row (`.bar`) above a bordered table
// or an `EmptyState` in the same border.
const TABS = ['Package Balances', 'Templates'];

export default function PackagesPage() {
  const [tab, setTab] = useState(0);

  return (
    <AppShell title="Packages">
      <div className={s.page}>
        <Tabs tabs={TABS} current={tab} onChange={setTab} />
        {tab === 0 ? <PackageBalancesPanel /> : <PackageTemplatesPanel />}
      </div>
    </AppShell>
  );
}
